var Node = require('../hierarchy/frResultNode');


module.exports = Node.extend({


    defaults: function() {

        var base = _.result( Node.prototype,  'defaults' );

        return _.extend( {}, base, {

            nodeType: 'SEARCH',
            rowLevel: 1,

            parentIdAttribute: 'searchId', // cid ..
            search: null,
            note: null

        });

    },


    getNote: function() {
        return this.get('note');
    },

    getSearch: function() {
        return this.get('search');
    }



});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/searchHierarchy/SearchResult.js
 ** module id = 672
 ** module chunks = 0
 **/